export default __webpack_public_path__ + "static/media/default-profile.4edd1b2e.svg";